
export enum StaffProfession {
    None = 'None',
    Cosmetician = 'Cosmetician',
    Manicure = 'Manicure',
    Pedicure = 'Pedicure',
    Masseur = 'Masseur',
    NailArtist = 'NailArtist',
    MakeUpTattooist = 'MakeUpTattooist',
    MensHaircut = 'MensHaircut',
    Tattooist = 'Tattooist',
    WomensHaircut = 'WomensHaircut',
}
